// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import DataTableCellBase from "@insite/mobius/DataTable/DataTableCellBase";
import { IconWrapper } from "@insite/mobius/Icon";
import { StyledIcon } from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import dataTableStyles from "@steiner/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { FormInputWrapper } from "@steiner/MobiusOverrides/FormField";
import { listStyles } from "@steiner/Overrides/Widgets/MyLists/MyListsList";
import List from "@steiner/XDL/Icons/List";
import Table from "@steiner/XDL/Icons/Table";
import Trash from "@steiner/XDL/Icons/Trash";
import { color, ellipsis, modalButtonsActionStyles, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

listStyles.messageText = {
    ...dataTableStyles.noResultsText,
};

listStyles.notifyWrapper = {
    css: css`
        width: 100%;
        display: flex;
        align-items: flex-start;
    `,
};

listStyles.cardList = {
    gridContainer: {
        gap: 0,
    },
};

listStyles.cardContainer = {
    cardDivider: {
        css: css`
            width: 100%;
            padding-top: 13px;
            padding-bottom: 13px;
            margin: 0;
            background: ${getColor("common.white")};
            &:not(:last-child) {
                border-bottom: 1px solid ${getColor("common.border")};
            }
            &:last-child {
                border-bottom: none;
            }
        `,
    },
};

listStyles.view = {
    css: css`
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        margin-bottom: 12px;
    `,
};

listStyles.listViewLink = {
    icon: {
        position: "left",
        iconProps: {
            src: List,
            size: 21,
            css: css`
                margin-right: 0;
            `,
        },
    },
    css: css`
        ${({ active }: any) =>
            active
                ? css`
                      ${StyledIcon} {
                          color: ${color("primary")};
                      }
                  `
                : css`
                      ${StyledIcon} {
                          color: ${color("common.ui4")};
                      }
                  `}
    `,
};

listStyles.tableViewLink = {
    icon: {
        position: "left",
        iconProps: {
            src: Table,
            size: 21,
            css: css`
                margin-right: 0;
            `,
        },
    },
    css: css`
        ${({ active }: any) =>
            active
                ? css`
                      ${StyledIcon} {
                          color: ${color("primary")};
                      }
                  `
                : css`
                      ${StyledIcon} {
                          color: ${color("common.ui4")};
                      }
                  `}
    `,
};
listStyles.dataTableRow = {
    css: css`
        position: relative;
        ${xScreen("lte", "sm")} {
            & ${DataTableCellBase}:first-child {
                position: static;
            }
        }
    `,
};

listStyles.addProductGroupToCartButton = {
    mergeCss: true,
    css: css`
        min-width: 260px;
        ${xScreen("lte", "md")} {
            padding: 6px 12px 5px;
            width: 42px;
            min-width: 42px;
            margin-top: 5px;
            ${IconWrapper} {
                width: 18px;
                height: auto;
                position: static;
                margin-left: 0;
                justify-content: center;
            }
            &[data-status="default"] {
                ${IconWrapper} {
                    color: ${color("common.ui6")};
                }
            }
            &[data-status="loading"]::before {
                margin-right: 0;
            }
        }
    `,
};
listStyles.deleteLink = {
    icon: {
        iconProps: { src: Trash, size: 16 },
    },
    css: css`
        ${xScreen("lte", "md")} {
            position: absolute;
            bottom: 25px;
            right: 5px;
        }
    `,
};

listStyles.viewText = {
    size: 14,
};

listStyles.listNameDataTableCell = {
    mergeCss: true,
    css: css`
        word-wrap: break-word;
        white-space: normal;
        ${TypographyStyle} {
            ${ellipsis(1)}
        }

        ${xScreen("lte", "md")} {
            &&& ${StyledButton} {
                margin-left: 0;
            }
        }
    `,
};

listStyles.dateDateTableCell = {
    css: css`
        ${xScreen("lte", "md")} {
            p  {
                text-align: left;
            }
        }
    `,
};

listStyles.addToCartDataTableCell = {
    mergeCss: true,
    css: css`
        ${xScreen("gt", "lg")} {
            width: 300px;
        }
    `,
};

listStyles.deleteProductGroupModal = {
    buttonsGridItem: { ...modalButtonsActionStyles.buttonsGridItem },
    submitButton: { ...modalButtonsActionStyles.submitButton },
    cancelButton: { ...modalButtonsActionStyles.cancelButton },
};

listStyles.leaveProductGroupModal = {
    buttonsGridItem: { ...modalButtonsActionStyles.buttonsGridItem },
    submitButton: { ...modalButtonsActionStyles.submitButton },
    cancelButton: { ...modalButtonsActionStyles.cancelButton },
};
